import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, model } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { NavRouterLinkDirective } from '@navfleet/client/navigation/utils';
import { IconContainer } from '@navfleet/client/shared/components/icon/ui';
import { SideMenuItem } from '@navfleet/client/shell/domain/models';
import { TranslatePipe } from '@ngx-translate/core';
import { Divider } from '@openng/optimus-ui/divider';
import { Menu } from '@openng/optimus-ui/menu';

@Component({
    imports: [IconContainer, TranslatePipe, NavRouterLinkDirective, RouterLinkActive, Menu, NgTemplateOutlet, Divider],
    selector: 'fl-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
    public readonly items = input<SideMenuItem[]>([]);
    public readonly isMinimized = model<boolean>(false);

    public readonly toggleItem = computed<SideMenuItem>(() => ({
        route: {
            path: '',
            title: 'SIDEMENU.HIDE',
        },
        icon: this.isMinimized() ? 'pi-chevron-right' : 'pi-chevron-left',
    }));
}
